module.exports = __webpack_public_path__ + "files/60bdb28dc8230486c5b0e868c82fb5dc.woff";


//////////////////
// WEBPACK FOOTER
// ./fonts/open-sans-v13-latin-ext_latin_cyrillic-ext_greek-ext_greek_cyrillic_vietnamese-regular.woff
// module id = 1436
// module chunks = 60